  // const dbId = "63e39b0694c858"; 
  // const baseURL = "http://192.168.1.252/k3cloud"; 
  // const srcURL = "http://192.168.1.252/K3CloudFIleServer/download.aspx?fileId="; 
  // const initSrcURL = "http://192.168.1.252/K3CloudFIleServer/download.aspx?fileId=2fa3b19c775a44409bd4e6c84c459bb3&dbId="+dbId; 
  // const username = "存良"; 
  // const appid = "241621_5f2A36uHROk45YUpX+1PU/SHTJ762Cts"; 
  // const appSecret = "794545b9aba747b5907db97ba0fd6b2b"; 
  // const wsUrl = 'ws://192.168.1.252:8181'; 
  // const uploadUrl = 'http://192.168.1.252/k3cloud/FileUpLoadServices/FileService.svc/upload2attachment/'; 


  // //正式环境
  const dbId = "649993e422ef93"; 
  const baseURL = "http://111.61.250.175:16870/K3Cloud"; 
  const srcURL = "http://111.61.250.175:16870/K3CloudFIleServer/download.aspx?fileId="; 
  const initSrcURL = "http://111.61.250.175:16870/K3CloudFIleServer/download.aspx?fileId=2fa3b19c775a44409bd4e6c84c459bb3&dbId="+dbId; 
  const username = "白宗玉"; 
  const appid = "241456_7ZaIWcgE6Pl/4//p650PVxwv3j3a7olv"; 
  const appSecret = "b772386122be49a6adda6871ff40a123"; 
  const wsUrl = 'ws://111.61.250.175:8181'; 
  const uploadUrl = 'http://111.61.250.175:16870/k3cloud/FileUpLoadServices/FileService.svc/upload2attachment/'; 


  export default
  {
    baseURL,
    dbId,
    srcURL,
    initSrcURL,
    username,
    appid,
    appSecret,
    wsUrl,
    uploadUrl
  }